angular.module('app').directive('apFooter',
    [
        'SessionService',
        'LocalStorageRepository', 
        '$uibModal', 
        'ConsentRepository', 
        'aprgettext', 
        'TransitionManager',
        'BrowserService',
        function (
            SessionService, 
            LocalStorageRepository, 
            $modal, 
            ConsentRepository, 
            gettext, 
            TransitionManager,
            BrowserService
        ) {
            'use strict';
            return {
                restrict: 'E',
                templateUrl: '/app/partials/footer/views/apFooter.html',
                scope: true,
                transclude: false,
                link: function (scope) {

                    scope.apFooter = {
                        PatientAuthenticated: SessionService.getPatientAuthenticated()
                    };

                    function contactUs() {
                        TransitionManager.transition({appRoute: 'contactus'});
                    }

                    function viewPracticeTerms() {

                        var modalInstance = $modal.open({
                            templateUrl: '/app/views/modals/practicetermsmodal.html',
                            controller: 'PracticeTermsModalCtrl',
                            windowClass: 'modal-full',
                            resolve: {}
                        });

                        modalInstance.result.then(function () {
                        });
                    }

                    function viewPrivacyPolicy() {
                        scope.isModalDisplayed = true;

                        var modalConfig = {
                            Title: gettext('Privacy Policy'),
                            DocumentId: 'privacypolicy',
                            DocumentLoad: getPrivacyPolicy,
                            DocumentDownload: downloadPrivacyPolicy,
                            DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                        };

                        var modalInstance = $modal.open({
                            templateUrl: '/app/views/viewDocumentModal.html',
                            controller: 'ViewDocumentModalCtrl',
                            windowClass: 'modal-full',
                            resolve: {
                                modalConfig: function () {
                                    return modalConfig;
                                }
                            }
                        });

                        modalInstance.result.then(function () {
                            scope.isModalDisplayed = false;
                        });
                    }

                    function viewApiDocumentation() {
                        scope.isModalDisplayed = true;

                        var modalConfig = {
                            Title: gettext('API Documentation'),
                            DocumentId: 'apidocumentation',
                            DocumentLoad: getApiDocumentation,
                            DocumentDownload: downloadApiDocumentation,
                            DisableInlinePdf: !BrowserService.supportsInlinePdf(),
                            ClientID: LocalStorageRepository.getClientID() || '',
                            ClientURL: LocalStorageRepository.getClientURL() || '',
                        };

                        var modalInstance = $modal.open({
                            templateUrl: '/app/views/viewApiDocumentModal.html',
                            controller: 'ViewApiDocumentModalCtrl',
                            windowClass: 'modal-full',
                            resolve: {
                                modalConfig: function () {
                                    return modalConfig;
                                }
                            }
                        });

                        modalInstance.result.then(function () {
                            scope.isModalDisplayed = false;
                        });
                    }

                    function viewApiDocumentationGatekeeper() {
                        scope.isModalDisplayed = true;

                        var modalConfig = {
                            Title: gettext('API Documentation Disclaimer'),
                            DisplayAPIDocumentationModal: viewApiDocumentation,
                            PatientAuthenticated: scope.apFooter.PatientAuthenticated,
                        };

                        var modalInstance = $modal.open({
                            templateUrl: '/app/views/modals/apidocumentationgatekeepermodal.html',
                            controller: 'ApiDocumentationGatekeeperModalCtrl',
                            windowClass: 'modal-lg',
                            resolve: {
                                modalConfig: function () {
                                    return modalConfig;
                                }
                            }
                        });

                        modalInstance.result.then(function (data) {
                            scope.isModalDisplayed = false;
                            if (data === 'ok') {
                                viewApiDocumentation();
                            }
                        });
                    }

                    function getPrivacyPolicy() {
                        return ConsentRepository.downloadAgreementPrivacyPolicy();
                    }

                    function downloadPrivacyPolicy(){
                        return ConsentRepository.downloadAgreementPrivacyPolicy()
                            .then(function (data) {
                                return {Data: data.Data, FileName: 'PrivacyPolicy', Extension: 'pdf'};
                            });
                    }

                    function getApiDocumentation() {
                        return ConsentRepository.downloadApiDocumentation();
                    }

                    function downloadApiDocumentation() {
                        return ConsentRepository.downloadApiDocumentation()
                            .then(function (data) {
                                return {Data: data.Data, FileName: 'APIPatientDocumentation', Extension: 'pdf'};
                            });
                    }

                    var patientAuthenticatedListener = scope.$on('PatientAuthenticated:updated', function (event, data) {
                        scope.apFooter.PatientAuthenticated = data;
                    });

                    scope.$on('$destroy', function () {
                        patientAuthenticatedListener();
                    });

                    scope.contactUs = contactUs;
                    scope.viewPrivacyPolicy = viewPrivacyPolicy;
                    scope.viewPracticeTerms = viewPracticeTerms;
                    scope.viewApiDocumentationGatekeeper = viewApiDocumentationGatekeeper;
                }
            };
        }
    ]
);